import __request__ from "routing/request";
export function queryStringUsed(queryStringRequest) {
  return __request__("POST", "/search/query_strings", queryStringRequest, {}, {
    "Accept": ["application/json"]
  });
}
